var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { toJS } from "mobx";
import isEqual from "lodash.isequal";
import _get from "lodash.get";
import dayjs from "dayjs";
import { generate, generateFromTree } from "./generator";
import { parseProgram } from "./parser";
function evalInContext(code, context) {
    return function () {
        var vars = Object.keys(context || {});
        var params = vars.map(function (key) { return context[key]; });
        return new (Function.bind.apply(Function, __spreadArray(__spreadArray([void 0], vars), ["values",
            "and",
            "or",
            "not",
            "eq",
            "gt",
            "lt",
            "max",
            "min",
            "contains",
            "add",
            "substract",
            "mul",
            "div",
            "get",
            "formatDate",
            "formatToTimestamp", "return (" + code + ");"])))().apply(void 0, __spreadArray(__spreadArray([], params), [values,
            and,
            or,
            not,
            eq,
            gt,
            lt,
            max,
            min,
            contains,
            add,
            substract,
            mul,
            div,
            get,
            formatDate,
            formatToTimestamp]));
    }.call(context);
}
export function values(first) {
    return first;
}
export function and(a, b) {
    return a && b;
}
export function or(a, b) {
    return a || b;
}
export function not(a) {
    return !a;
}
export function eq(a, b) {
    return isEqual(toJS(a), toJS(b));
}
export function gt(a, b) {
    return a > b;
}
export function lt(a, b) {
    return a < b;
}
export function max() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Math.max.apply(Math, args);
}
export function min() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Math.min.apply(Math, args);
}
export function contains(source, target) {
    return source.indexOf(target) > -1;
}
export function add() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values.reduce(function (a, b) {
        return a + b;
    });
}
export function substract() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values.reduce(function (a, b) {
        return a - b;
    });
}
export function mul() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values.reduce(function (a, b) {
        return a * b;
    });
}
export function div() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values.reduce(function (a, b) {
        return a / b;
    });
}
function get(target, path) {
    if (!path) {
        return target;
    }
    return _get(target, path);
}
function formatDate(input, options) {
    var _a = options || {}, inputFormat = _a.inputFormat, strict = _a.strict, locale = _a.locale, format = _a.format;
    var v = input;
    if (typeof v === "string") {
        v = Number(v);
    }
    return dayjs(v, inputFormat, locale, strict).format(format);
}
function formatToTimestamp(input) {
    return dayjs(input).valueOf();
}
export function apply(input, context) {
    var code = generate(parseProgram(input));
    return evalInContext(code, context);
}
export function applyTree(tree, context) {
    return apply(generateFromTree(tree), context);
}
